import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Container,
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const InventoryDetails = () => {
  const [child_modal_list, setchild_modal_list] = useState(false);
  const [child_modal_list2, setchild_modal_list2] = useState(false);
  const [child_modal_list3, setchild_modal_list3] = useState(false);
  const [addInventory, setAddInventory] = useState(null);

  function child_tog_list() {
    setchild_modal_list(!child_modal_list);
  }
  function child_tog_list2() {
    setchild_modal_list2(!child_modal_list2);
  }
  function child_tog_list3() {
    setchild_modal_list3(!child_modal_list3);
  }

  const [responseMessage, setResponseMessage] = useState("");

 // const authToken = JSON.parse(localStorage.getItem("authUser")).token;

  const [machineData, setMachineData] = useState();
  const fetchMachine = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/machine", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
        // },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setMachineData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [childPart, setChildPart] = useState();
  const fetchChildParts = async (e) => {
    try {
      // Fetch data from your API
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/childParts/${e}`,
        {
          method: "GET",
          // headers: {
          //   //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("this is child part data", data);
        setChildPart(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
  };

  useEffect(() => {
    fetchMachine();
    // fetchChildParts();
  }, []);

  const [render, setRender] = useState(false);

  const [formData, setFormData] = useState({
    machine: "",
    partName: "",
    stock: "",
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  //adding and removing input fields

  const handleSubmit = async (e) => {
    e.preventDefault();

    const apiUrl = "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/create/inventory";
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json", // Specify content type as JSON
        //   Authorization: `Bearer ${authToken}`,
        // },
        body: JSON.stringify(formData), // Serialize formData to JSON string,
      });

      const responseData = await response.json();
      //   console.log("from responseData:", responseData);
      if (response.ok) {
        toast.success(responseData.message);

        // Clear form data
        setFormData({
          machine: "",
          partName: "",
          stock: "",
        });

        setchild_modal_list(false);
        setRender(!render);
      } else {
        toast.error(`Error: ${responseData.error}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const [inventory, setInventory] = useState([]);

  const fetchInventory = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/inventory", {
        method: "GET",
        // headers: {
        //   //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
        // },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log("this is child part data", data);
        setInventory(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
  };

  const addStock = async (e) => {
    e.preventDefault();
    try {
      const stock = document.getElementById("stock").value;

      const requestBody = {
        stock: stock,
      };
      console.log(requestBody);

      // Update user on the server
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/add/inventory/${addInventory._id}`,
        {
          method: "PATCH",
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      //   console.log(responseData);

      if (response.ok) {
        toast.success("Stock Added Successfully");
        // Update the local state with the new user data
        setchild_modal_list2(false);
        setRender(!render);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error adding stock:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding stock:", error);
    }
  };
  const removeStock = async (e) => {
    e.preventDefault();
    try {
      const stock = document.getElementById("stock").value;

      const requestBody = {
        stock: stock,
      };
      console.log(requestBody);

      // Update user on the server
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/remove/inventory/${addInventory._id}`,
        {
          method: "PATCH",
          // headers: {
          //   "Content-Type": "application/json",
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      //   console.log(responseData);

      if (response.ok) {
        toast.success("Stock Removed Successfully");
        // Update the local state with the new user data
        setchild_modal_list3(false);
        setRender(!render);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error adding stock:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding stock:", error);
    }
  };

  const handleDeleteInventory = async (inventoryId) => {
    console.log(inventoryId);
    try {
      // Make API request to delete the user
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/delete/inventory/${inventoryId}`,
        {
          method: "DELETE",
          // headers: {
          //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
          // },
        }
      );
      //   console.log(response);

      if (response.ok) {
        toast.success("Inventory Deleted Successfully");
        // If the deletion was successful, refresh the user data
        // fetchChildParts();
        setRender(!render);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error in deleting:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  useEffect(() => {
    fetchInventory();
  }, [render]);

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredInventoryData = inventory.filter((data) =>
    // machine.company_name.company_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    data.machine.machine_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleInputChangeWrapper = (e) => {
    // Call the original handleInputChange function
    handleInputChange(e);

    // Call the additional function
    fetchChildParts(e.target.value);
    // console.log(e.target.value);
  };

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredInventoryData.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredInventoryData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Inventory" />
          <Row>
            {responseMessage && (
              <div
                className={`alert ${
                  responseMessage.includes("Error")
                    ? "alert-danger"
                    : "alert-success"
                }`}
              >
                {responseMessage}
              </div>
            )}
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove Inventory
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => child_tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add Inventory Details
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="email">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="email">
                              Part No.
                            </th>
                            <th className="sort" data-sort="email">
                              Current Stock
                            </th>

                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((inventory, index) => (
                              <tr key={index}>
                                <td className="email">
                                  {inventory.machine?.machine_name}
                                </td>
                                <td className="email">{inventory.partName}</td>
                                <td>{inventory.stock}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          child_tog_list2();
                                          setAddInventory(inventory);
                                        }}
                                      >
                                        Add stock
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-warning remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() => {
                                          child_tog_list3();
                                          setAddInventory(inventory);
                                        }}
                                      >
                                        Remove stock
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() =>
                                          handleDeleteInventory(inventory._id)
                                        }
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add & Edit Child Parts */}

      <Modal
        isOpen={child_modal_list}
        toggle={() => {
          setchild_modal_list(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel1"
          toggle={() => {
            child_tog_list();
          }}
        >
          Add Inventory Details
        </ModalHeader>

        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="partName" className="form-label">
                Select Machine
              </label>
              <select
                id="machine"
                className="form-control"
                // onChange={handleInputChange}
                // value={formData.partName}
                value={formData.machine._id}
                onChange={handleInputChangeWrapper}
              >
                <option key="default">Select Machine</option>
                {machineData?.map((part, index) => (
                  <option key={index} value={part._id}>
                    {part.machine_name}
                  </option>
                ))}
                {/* {childPart?.map((part, index) =>
                  part.childParts?.map((childPart, childIndex) => (
                    <option key={childIndex} value={childPart.value}>
                      {childPart.value}
                    </option>
                  ))
                )} */}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="partName" className="form-label">
                Select Part
              </label>
              <select
                id="partName"
                className="form-control"
                onChange={handleInputChange}
                value={formData.partName}
              >
                <option key="default">Select Part</option>
                {/* {machineData?.map((part, index) => (
                  <option key={index} value={part.machine_name}>
                    {part.machine_name}
                  </option>
                ))} */}
                {childPart?.map((part, index) =>
                  part.childParts?.map((childPart, childIndex) => (
                    <option key={childIndex} value={childPart.value}>
                      {childPart.value}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="stock" className="form-label">
                Stock
              </label>
              <input
                type="number"
                id="stock"
                className="form-control"
                placeholder="stock"
                value={formData.stock}
                onChange={handleInputChange}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setchild_modal_list(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                Add
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>

      <Modal
        isOpen={child_modal_list2}
        toggle={() => {
          setchild_modal_list2(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel1"
          toggle={() => {
            child_tog_list2();
          }}
        >
          Add Stock
        </ModalHeader>

        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="stock" className="form-label">
                Add Stock
              </label>
              <input
                type="number"
                id="stock"
                className="form-control"
                placeholder="stock"
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setchild_modal_list2(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={addStock}
              >
                {" "}
                Add
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>

      <Modal
        isOpen={child_modal_list3}
        toggle={() => {
          setchild_modal_list3(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel1"
          toggle={() => {
            child_tog_list3();
          }}
        >
          Remove Stock
        </ModalHeader>

        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="stock" className="form-label">
                Remove Stock
              </label>
              <input
                type="number"
                id="stock"
                className="form-control"
                placeholder="stock"
                // value={formData.stock}
                // onChange={handleInputChange}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setchild_modal_list3(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={removeStock}
              >
                {" "}
                Remove
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default InventoryDetails;
